export const attendanceEvents = {
  overnightShiftConfigAdd: 'Overnight shift config add',
  overnightShiftConfigStart: 'Overnight shift config start',
  overnightShiftConfigSubmit: 'Overnight shift config submit',
}

export const timeTrackingEvents = {
  activateBreaksTTPolicy: 'Activate breaks TT policy',
  activatePayrollFromCompensation: 'Activate payroll from time tracking pressed',
  addShiftRequestAddStart: 'Add shift request (Add) start',
  addShiftRequestAddSubmit: 'Add shift request (Add) submit',
  addShiftRequestDeleteStart: 'Add shift request (Delete) start',
  addShiftRequestDeleteSubmit: 'Add shift request (Delete) submit',
  addShiftRequestEditStart: 'Add shift request (Edit) start',
  addShiftRequestEditSubmit: 'Add shift request (Edit) submit',
  addTimeBlock: 'Time block added',
  addWorkTimeCategory: 'Work time category added',
  addWorkTimeCategoryValue: 'Work time category value added',
  applyInconsistencyFilter: 'Apply inconsistency filter',
  applyRealTimeAttendanceFilter: 'Apply real time attendance filter',
  approvePendingPeriods: 'Approve pending timesheets',
  applyTimeTrackingFilters: 'Apply time tracking filters',
  approvePeriodFromTimesheet: 'Approve period from timesheet',
  bulkApprovePeriodFromTimesheet: 'Bulk approve period from timesheet',
  bulkDisapprovePeriodFromTimesheet: 'Bulk disapprove period from timesheet',
  bulkEmployeeSelect: 'Bulk employee select',
  bulkIncludeEmployees: 'Bulk include employees',
  bulkExcludeEmployees: 'Bulk exclude employees',
  compensatingCategories: 'Compensating categories',
  compensatingCategoriesFinish: 'Compensating categories finish',
  disableBreaksFromTT: 'Disable breaks from TT',
  disapproveApprovedPeriods: 'Disapprove approved timesheets',
  disapprovePeriodFromTimesheet: 'Disapprove period from timesheet',
  periodChangedFromDateNavigator: 'Period changed from date navigator',
  editBreakManuallySubmit: 'Edit or add break manually submit',
  editClockOut: 'Edit clock out',
  editShiftManuallySubmit: 'Edit or add shift manually submit',
  editShiftRequestStart: 'Edit shift request start',
  editShiftRequestSubmit: 'Edit shift request submit',
  employeeSelectRow: 'Select employee row',
  employeesPolicyCount: 'Employees policy count',
  enableBreaksFromTT: 'Enable breaks from TT',
  endLoadingTimeTrackingView: 'End loading Time tracking view',
  excludeEmployeesTimeTrackingStart: 'Exclude employees from Time Tracking start',
  excludeEmployeesTimeTrackingSubmit: 'Exclude employees from Time Tracking submit',
  expandOrCollapseAllDayRows: 'Expand or collapse all day rows',
  expandOrCollapseDayRow: 'Expand or collapse day row',
  exportTimeTrackingStart: 'Export time tracking start',
  exportTimeTrackingSubmit: 'Export time tracking submit',
  goToCreateWorkTimeCategories: 'Create work time categories',
  goToEmployeeClockIn: "Go to employee's clock in page",
  goToEmployeeTimeSheet: 'Go to employee timesheet',
  openTTCollectionSidepanelFromRow: 'Open time tracking collection employee summary from row',
  openTTCollectionSidepanelFromDetailsButton:
    'Open time tracking collection employee summary from details button',
  goToEmployeeTimeSheetFromTTSidepanel: 'Go to employee timesheet from time tracking sidepanel',
  goToShiftLocationMap: 'Go to shift locations map',
  goToTimeTrackingFromRTAWidget: 'Go to time tracking from RTA widget',
  goToTimeTrackingView: 'Go to Time Tracking View',
  goToWorkTimeCategoryValues: 'Go to Work time categorization',
  goToClockInWidgetFromTimesheet: 'Go to clock in widget from timesheet',
  hoverInconsistencyTooltip: 'Hover inconsistency tooltip',
  inconsistenciesModalActionTaken: 'Inconsistencies modal action taken',
  inconsistenciesModalDisplayed: 'Inconsistencies modal displayed',
  navigateGeolocationMap: 'See geolocation map',
  navigateToTimeTrackingSettingsPage: 'Go to Time Tracking settings',
  newCategoryPressed: 'New category value time tracking policy pressed',
  openGeolocationMap: 'Open geolocation map',
  openHintModalTimeTracking: 'Open hint modal time tracking',
  cancelHintModalTimeTracking: 'Cancel hint modal time tracking',
  payrollMappingsModalSavePressed: 'Payroll mappings modal save pressed',
  resolveInconsistency: 'Resolve inconsistency',
  seeBalanceBreakdownTooltip: 'See balance breakdown tooltip',
  seeEstimatedHoursTooltip: 'See estimated hours tooltip',
  seeLeaveTooltip: 'See leave tooltip',
  seeRealTimeAttendanceTooltip: 'See real time attendance tooltip',
  seeWorkedHoursTooltip: 'See worked hours tooltip',
  selectNextPeriod: 'Select next period',
  selectPeriodType: 'Period type selected',
  selectPreviousPeriod: 'Select previous period',
  sendClockInReminderStart: 'Send clock in reminder start',
  sendClockInReminderSubmit: 'Send clock in reminder submit',
  setTimeCategoriesFromTT: 'Discovery banner time categories on Time Tracking page pressed',
  sidePanelCompensatePressed: 'Compensation sidepanel compensate button pressed',
  timesheetCompensatePressed: 'Timesheet compensate button pressed',
  startBackToWork: 'Start back to work',
  startBreak: 'Start break',
  startClockIn: 'Start clock in',
  startClockOut: 'Start clock out',
  timeCategoriesSettingsPageVisited: 'Time categories settings page visited',
  timeCompensationSetupFromSidepanel: 'Time compensation setup from sidepanel pressed',
  toggleClockOutRestrictions: 'Toggle clock out restrictions',
  toggleMissingClockInAlert: 'Toggle missing clock in alert',
  toggleShiftEditRestriction: 'Toggle shift edit restriction',
  changeReferencePoint: 'Change reference point',
  newSpecialHourPressed: 'New special hour pressed',
  newSpecialHourStep1NextPressed: 'New special hour step 1 next pressed',
  newSpecialHourStep2NextPressed: 'New special hour step 2 next pressed',
  newSpecialHourStep3NextPressed: 'New special hour step 3 next pressed',
  payrollTaxonomyMapped: 'Payroll taxonomy mapped',
  specialHoursWizardClosedBeforeFinishing: 'Special hours wizard closed before finishing',
  specialHoursTableAddPressed: 'Special hours table add pressed',
  specialHoursTableEditPressed: 'Special hours table edit pressed',
  specialHoursTableRemovePressed: 'Special hours table remove pressed',
  specialHoursTableDownloadWorkedHoursButtonPressed:
    'Special hours table download worked hours button pressed',
  goToWorkTimeCategoriesSettingsLinkPressed: 'Go to work time categories settings link pressed',
  newSpecialHourNameCreated: 'New special hour name created',
  newExtraHourNameCreated: 'New extra hour name created',
  baseRuleEditPressed: 'Base rule edit pressed',
  customRuleEditPressed: 'Custom rule edit pressed',
  baseRuleCompensationPressed: 'Base rule compensation pressed',
  customRuleCompensationPressed: 'Custom rule compensation pressed',
  customRuleHoursRangeTypePressed: 'Custom rule hours range type pressed',
  customRuleHourlyRateNextPressed: 'Custom rule hourly rate next pressed',
  callOutTimeOffSettingsLinkPressed: 'Call out time off settings link pressed',
  baseRuleSubmitPressed: 'Base rule submit pressed',
  customRuleSubmitPressed: 'Custom rule submit pressed',
  newExtraHourRulePressed: 'New extra hour rule pressed',
  customRuleDeletePressed: 'Custom rule delete pressed',
  poolCapacityPressed: 'Pool capacity pressed',
  negativeBalanceSettlementPressed: 'Negative balance settlement pressed',
  dailyClockIn: {
    clockIn: 'Daily clock in',
  },
}
